// extracted by mini-css-extract-plugin
module.exports = {"photo":"photo_photo__ufptX","photo__image":"photo_photo__image__rLYdz"};